module.exports = __webpack_public_path__ + "static/media/fishin-carava-feature-2.3f55a042.png";